export const URL_CHAT_JUSIA = 'https://ia.jusbrasil.com.br/conversa'

export const JUSIA_API_BASE_URL = process.env.JUSIA_API_BASE_URL || 'http://localhost:4510'

export const JUSIA_ALLOWED_ORIGINS = {
  SIMILAR_DOCUMENTS: 'legal_research_similar_documents',
  SEARCH_FROM_CONTEXT_MENU: 'legal_research_search_from_context_menu',
  RELATED_QUESTIONS_IN_JURIS_DOCVIEW: 'legal_research_related_questions_in_juris_docview',
  RELATED_QUESTIONS_IN_JURIS_SERP: 'legal_research_related_questions_in_juris_serp',
  AI_OVERVIEW: 'legal_research_ai_overview',
  JUSIA_SELECTION_SHORTCUT: 'legal_research_jusia_selection_shortcut',
  LAWSUIT_ANALYSIS: 'legal_research_lawsuit_analysis',
  JUSIA_CONTEXT_BUTTON: 'legal_research_jusia_context_button',
  THESIS_SECURITY: 'legal_research_thesis_security',
  JUSIA_FLOATING_BUTTON: 'legal_research_jusia_floating_button',
  AI_RELATED_QUESTIONS: 'legal_research_ai_related_questions',
  NO_RESULTS_JUSIA_CTA: 'legal_research_no_results_jusia_cta',
  HOME_JURIS_SEARCH: 'legal_research_home_juris_search',
  THESIS_FOLLOW_UP_QUESTIONS: 'legal_research_thesis_follow_up_questions',
  THESIS_EXPLORE_WITH_JUS: 'legal_research_thesis_explore_with_jus',
  THESIS_STATIC_ANSWER_CTA: 'legal_research_thesis_static_answer_cta',
  THESIS_STATIC_CHAT_INPUT: 'legal_research_thesis_static_chat_input',
  HOME_LEGIS_SEARCH: 'legal_research_home_legis_search',
  HOME_DOCTRINE_SEARCH: 'legal_research_home_doctrine_search',
  HOME_PECAS_SEARCH: 'legal_research_home_pecas_search',
  HOME_MODELOS_SEARCH: 'legal_research_home_modelos_search',
} as const

export const BYPASS_SERP_ORIGINS_FF = {
  featureFlag: 'bypass_jusia',
  values: {
    control: 'control',
    enabledBypass: 'enabled-bypass',
  },
} as const

export const BYPASS_ORIGINS = new Set<string>([
  JUSIA_ALLOWED_ORIGINS.JUSIA_CONTEXT_BUTTON,
  JUSIA_ALLOWED_ORIGINS.JUSIA_FLOATING_BUTTON,
  JUSIA_ALLOWED_ORIGINS.AI_OVERVIEW,
  JUSIA_ALLOWED_ORIGINS.RELATED_QUESTIONS_IN_JURIS_SERP,
  JUSIA_ALLOWED_ORIGINS.NO_RESULTS_JUSIA_CTA,
  JUSIA_ALLOWED_ORIGINS.SIMILAR_DOCUMENTS,
  JUSIA_ALLOWED_ORIGINS.SEARCH_FROM_CONTEXT_MENU,
  JUSIA_ALLOWED_ORIGINS.LAWSUIT_ANALYSIS,
  JUSIA_ALLOWED_ORIGINS.RELATED_QUESTIONS_IN_JURIS_DOCVIEW,
  JUSIA_ALLOWED_ORIGINS.JUSIA_SELECTION_SHORTCUT,
])
